/**
 * 店铺可发类目展示语言：按同步入库的 nameZh / nameEn 切换。
 * 跟随全局 i18n（中文界面用 nameZh，其它语言用 nameEn）。
 */

import i18n from '@/i18n';

/** @returns {'zh'|'en'} */
export function resolveCategoryDisplayLang(language) {
  const lang = String(
    language || i18n.resolvedLanguage || i18n.language || 'zh-CN',
  ).toLowerCase();
  if (lang.startsWith('zh')) return 'zh';
  return 'en';
}

/** @deprecated 请用 resolveCategoryDisplayLang；保留兼容旧调用 */
export function readCategoryDisplayLang() {
  return resolveCategoryDisplayLang();
}

/** @deprecated 展示语言由 i18n 决定，写入无效 */
export function writeCategoryDisplayLang(_lang) {
  return resolveCategoryDisplayLang();
}

function pickDisplayName(node, lang) {
  if (!node || typeof node !== 'object') return '';
  const zh = String(node.nameZh || node.local_name_zh || '').trim();
  const en = String(node.nameEn || node.local_name_en || '').trim();
  const fallback = String(
    node.category_name || node.catName || node.local_name || node.name || '',
  ).trim();
  if (lang === 'zh') {
    return zh || en || fallback;
  }
  return en || zh || fallback;
}

/** 按 zh/en 生成展示用类目树（保留 id / children，仅改名称字段）。 */
export function applyCategoryDisplayLang(raw, lang = 'en') {
  const list = Array.isArray(raw) ? raw : [];
  const walk = (nodes) => {
    if (!Array.isArray(nodes)) return [];
    return nodes.map((node) => {
      if (!node || typeof node !== 'object') return node;
      const name = pickDisplayName(node, lang);
      const childrenRaw = node.children ?? node.categoryDTOList;
      const children = walk(Array.isArray(childrenRaw) ? childrenRaw : []);
      return {
        ...node,
        category_name: name,
        catName: name,
        local_name: name,
        children,
        categoryDTOList: children,
      };
    });
  };
  return walk(list);
}
